import { render, staticRenderFns } from "./tdprequest.vue?vue&type=template&id=7a3da774"
import script from "./tdprequest.vue?vue&type=script&lang=js"
export * from "./tdprequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports